<script lang="ts">
  import EditableDataTable from 'scripts/global_components/EditableDataTable.svelte';
  import { navigate } from 'svelte-routing';
  import { slipItemTableConfig2 } from 'scripts/purchase/config/store';
  import type { ChoiceDisplayMap } from 'scripts/utils/types';

  export let slipItems: any[] = [];
  export let choiceDisplayMap: ChoiceDisplayMap = {};
</script>

<div class="row p-2">
  <div class="col-12">
    <EditableDataTable
      on:trClick={(e) => navigate(`${e.detail.item.detail_url}`)}
      items={slipItems}
      bind:tableConfig={$slipItemTableConfig2}
      bind:choiceDisplayMap
      primaryKey="pk"
      csvDownload={true}
      csvFields={Object.keys($slipItemTableConfig2)}
    />
  </div>
</div>
